import {
  boxShadow,
  mediaHelper,
  MINIMUM_FOOTER_HEIGHT_PX,
  paletteHelper,
  SITE_HEADER_HEIGHT_PX,
  spacingHelper,
} from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { StatePageTitleWithData } from '../components/StatePageTitleWithData/StatePageTitleWithData';
import { PageContainer } from '../../components/PageContainer/PageContainer';
import { StatePageBreadCrumbsWithData } from '../components/StatePageBreadCrumbs/StatePageBreadCrumbs';
import { StatePageSeoFooterWithData } from '../components/StatePageSeoFooterWithData/StatePageSeoFooterWithData';
import { StatePageSuburbsWithData } from '../components/StatePageSuburbs/StatePageSuburbs';
import { StatePagePropertyCollectionBricksWithData } from '../components/StatePagePropertyCollectionBricks/StatePagePropertyCollectionBricksWithData';
import { StatePageVGDisclaimerFooter } from '../components/StatePageVGDisclaimerFooter/StatePageVGDisclaimerFooter';

const ScreenContainer = styled.div`
  margin-top: ${SITE_HEADER_HEIGHT_PX}px;
  min-height: calc(100vh - ${MINIMUM_FOOTER_HEIGHT_PX}px);
  display: flex;
  flex-direction: column;
  background-color: ${paletteHelper('backgroundSecondaryBase')};
`;

const PageHeaderContainer = styled.div`
  background-color: ${paletteHelper('backgroundPrimaryHigh')};
  border-bottom: 1px solid ${paletteHelper('borderPrimary')};
  padding-bottom: ${spacingHelper('medium')};
  ${boxShadow.headerBoxShadow}
`;

const PageHeaderInnerContainer = styled(PageContainer)`
  padding-top: ${spacingHelper('large')};
  ${mediaHelper('tabletMax')} {
    padding-left: ${spacingHelper('large')};
    padding-right: ${spacingHelper('large')};
  }
`;

const PageContentContainer = styled(PageContainer)`
  display: flex;
  flex-direction: column;
  row-gap: ${spacingHelper('large')};
  padding: ${spacingHelper('medium')} 0 ${spacingHelper('large')};
  flex-grow: 1;

  ${mediaHelper('tabletMax')} {
    padding: ${spacingHelper('medium')} ${spacingHelper('extraSmall')} ${spacingHelper('large')};
  }
`;

const PageFooterContainer = styled(PageContainer)`
  display: flex;
  flex-direction: column;
  row-gap: ${spacingHelper('large')};
  flex-grow: 1;
`;

export const StatePageScreen: FunctionComponent = () => {
  return (
    <ScreenContainer as="main" id="main-content">
      <PageHeaderContainer>
        <StatePageBreadCrumbsWithData />
        <PageHeaderInnerContainer>
          <StatePageTitleWithData />
        </PageHeaderInnerContainer>
      </PageHeaderContainer>
      <PageContentContainer>
        <StatePagePropertyCollectionBricksWithData />
        <StatePageSuburbsWithData />
      </PageContentContainer>
      <PageFooterContainer>
        <StatePageVGDisclaimerFooter />
        <StatePageSeoFooterWithData />
      </PageFooterContainer>
    </ScreenContainer>
  );
};
